module.exports = __webpack_public_path__ + "img/bean-vermicelli.510f5a19.png";